/* eslint-disable array-bracket-newline */
/**
 * Selectable list of exchanges
 */
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';

import { IMobileFilterProps } from '../../../SearchTable/SearchTable';
import { TableFilterOption } from '..';

import checkmark from '../../../../assets/images/check.svg';

import './styles.scss';

export type TableFilterMobileOption = {
  title: string;
  id: string;
  options: TableFilterOption[];
};

export type TableFilterMobileData = {
  id: string;
  value?: string;
};

interface ITableFilterMobileProps extends IMobileFilterProps {
  filters: Record<string, string | null | undefined>;
  items: TableFilterMobileOption[];
}

const TableFilterMobile = ({
  filters,
  items,
  setFilterValue,
}: ITableFilterMobileProps) => {
  const onFilterSelect = (id: string, value?: string) => {
    setFilterValue!({ id, value });
  };

  return (
    <>
      {items.map(({ title, id, options }) => {
        return (
          <div key={id} className='filter_section'>
            <Text size={14} className='filter_section__title'>
              {title}
            </Text>
            {options.map((option) => {
              const isActive = filters[id] === option.value;
              return (
                <div
                  className={`chain_exchange_option${
                    isActive ? ' chain_exchange_option--active' : ''
                  }`}
                  key={option.value}
                  onClick={() =>
                    onFilterSelect(id, isActive ? undefined : option.value)
                  }
                >
                  <div className='chain_exchange_option__title'>
                    {isActive && (
                      <div className='chain_exchange_option__title__checkmark'>
                        <Image size='m' src={checkmark} />
                      </div>
                    )}
                    <Text size={14} className='text--weight-500'>
                      {option.label}
                    </Text>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

export default TableFilterMobile;
